module.exports = __webpack_public_path__ + "img/mod_art.a97b6328.svg";